import Modal from "../Modal/Modal";
import Button from "../Button/Button";


type DeleteProductModalProps = {
  isOpen: boolean;
  productName?: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
};

const DeleteProductModal = ({ isOpen, productName, onClose, onConfirm, loading }: DeleteProductModalProps) => {

  if (!isOpen) {
    return null;
  }

  return (
    <Modal overlayClassName="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center px-4">
      <div className="bg-white rounded-md shadow-xl px-6 py-8 relative w-full max-w-md">
        <h4 className="text-lg font-bold mb-3 text-center">{"Excluir produto?"}</h4>
        <p className="text-sm text-gray-700 mb-6 text-center">
          {productName ? (
            <>{"O produto"} <span className="font-semibold">"{productName}"</span> {"será excluído permanentemente."}</>
          ) : (
            "O produto será excluído permanentemente."
          )}
        </p>
        <div className="flex justify-center gap-4">
          <Button isLoading={loading} variant="danger"
            onClick={onConfirm}
            disabled={loading}
            className="px-5 py-2"
          >
            {"Sim, excluir"}
          </Button>
          <Button variant="secondary"
            onClick={onClose}
            disabled={loading}
            className="px-5 py-2"
          >
            {"Cancelar"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteProductModal;
